import { useEffect } from 'react'
import { useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { FdeEditorDialog } from '@/frontend/features/Fde/FdeEditorSurface'
import { SelectControl, TextareaControl, TextControl } from '@/frontend/features/Fde/FormControls'
import type { Evidence, FdeCopy } from '@/frontend/features/Fde/types'
import { fdeRoutes } from '@/frontend/features/Fde/routes'

interface Props { open: boolean; onOpenChange: (open: boolean) => void; evidence: Evidence | null; projectId: string; copy: FdeCopy }

export default function EvidenceEditorDialog({ open, onOpenChange, evidence, projectId, copy }: Props) {
  const form = useForm({ evidence_kind: 'note', title: '', excerpt: '', locator: '', occurred_at: '', status: 'confirmado' })
  useEffect(() => {
    if (!open || !evidence) return
    form.setData({
      evidence_kind: evidence.evidence_kind, title: evidence.title, excerpt: evidence.excerpt ?? '',
      locator: evidence.locator ?? '', occurred_at: evidence.occurred_at?.slice(0, 16) ?? '', status: evidence.status,
    })
  }, [open, evidence?.id])

  function submit() {
    if (!evidence) return
    form.transform((data) => ({ evidence: data }))
    form.patch(`${fdeRoutes.evidences}/${evidence.id}?project_id=${projectId}`, { preserveScroll: true, onSuccess: () => onOpenChange(false) })
  }

  return (
    <FdeEditorDialog
      open={open}
      onOpenChange={onOpenChange}
      title={copy.workspace.edit_evidence}
      closeLabel={copy.common.close}
      size="standard"
      footer={<><Button variant="outline" onClick={() => onOpenChange(false)}>{copy.common.cancel}</Button><Button disabled={form.processing || !form.data.title.trim()} onClick={submit}>{copy.common.save}</Button></>}
    >
        <div className="grid gap-5 sm:grid-cols-2">
          <TextControl label={copy.forms.element_kind} value={form.data.evidence_kind} onChange={(event) => form.setData('evidence_kind', event.target.value)} required />
          <TextControl label={copy.forms.name} value={form.data.title} onChange={(event) => form.setData('title', event.target.value)} required />
          <div className="sm:col-span-2"><TextareaControl label={copy.forms.excerpt} value={form.data.excerpt} onChange={(event) => form.setData('excerpt', event.target.value)} rows={4} /></div>
          <TextControl label={copy.forms.locator} value={form.data.locator} onChange={(event) => form.setData('locator', event.target.value)} />
          <TextControl label={copy.forms.occurred_at} type="datetime-local" value={form.data.occurred_at} onChange={(event) => form.setData('occurred_at', event.target.value)} />
          <SelectControl label={copy.forms.status} value={form.data.status} onChange={(value) => form.setData('status', value)} options={[{ value: 'proposto', label: copy.workspace.proposed }, { value: 'confirmado', label: copy.workspace.confirmed_status }]} />
        </div>
    </FdeEditorDialog>
  )
}
